const experienceData = [
  {
    slug: "hastings-direct",
    title: "Year of Industry at Hastings Direct",
    image: `${process.env.PUBLIC_URL}/images/experience/hastings.jpg`,
    date: "13-09-2024 - 13-09-2025",
    links: { company: "https://www.hastingsdirect.com/", certificate: "https://coursera.org/verify/4E16LYQ499E2" },
    description: "This placement was an amazing experience in which I learnt and developed my Industry standards and discovered my passion for Website development. I did several certifications (see my linked in) and met loads of highly skilled senior developers who I became acquainted with."
  },
  {
    slug: "hacksussex-committee",
    title: "Web dev for Hack Sussex Committee",
    image: `${process.env.PUBLIC_URL}/images/experience/hacksussex.jpg`,
    date: "02-09-2025 - 01-06-2026",
    links: { society: "https://www.hacksussex.com/" },
    description: "After getting my job at Hastings Direct because of the hackathon I attended, I thought it could be fun to spend my last year at University working for the Committee. I applied to be their web developer and worked on developing a new dashboard system and new front end website which was fun to do. I also helped out with the events and socials and got to meet lots of cool new people."
  }
];

export default experienceData;